import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import AppHeader from './AppHeader';

export default function Profile() {

  const theme = useTheme();

  const firstNameState = useSelector((state) => state.registration.firstName);
  const lastNameState = useSelector((state) => state.registration.lastName);
  const emailAddressState = useSelector((state) => state.registration.emailAddress);
  const mobileNumberState = useSelector((state) => state.registration.mobileNumber);

  return (

    <React.Fragment>

      <Box
        sx={{
          height: '100%',
          width: '100%',
          backgroundColor: '#3B4E68',
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: '20px',
        }}
      >

        <Box>
          <AppHeader />
        </Box>

        <Typography
          variant='body1'
          sx={{
            color: '#FFFFFF',
            fontSize: '24px',
            fontWeight: 'bold',
            textAlign: 'left',
            paddingLeft: '20px',
            paddingBottom: '10px',
          }}
        >
          Profile
        </Typography>

        <Typography
          variant='body1'
          sx={{
            color: '#FFFFFF',
            fontSize: '18px',
            textAlign: 'left',
            paddingLeft: '20px',
            paddingBottom: '10px',
          }}
        >
          First name: {firstNameState}
        </Typography>

        <Typography
          variant='body1'
          sx={{
            color: '#FFFFFF',
            fontSize: '18px',
            // fontWeight: 'bold',
            textAlign: 'left',
            paddingLeft: '20px',
            paddingBottom: '10px',
          }}
        >
          Last name: {lastNameState}
        </Typography>

        <Typography
          variant='body1'
          sx={{
            color: '#FFFFFF',
            fontSize: '18px',
            // fontWeight: 'bold',
            textAlign: 'left',
            paddingLeft: '20px',
            paddingBottom: '10px',
          }}
        >
          Mobile number: {mobileNumberState}
        </Typography>

        <Typography
          variant='body1'
          sx={{
            color: '#FFFFFF',
            fontSize: '18px',
            // fontWeight: 'bold',
            textAlign: 'left',
            paddingLeft: '20px',
            paddingBottom: '10px',
          }}
        >
          email address: {emailAddressState}
        </Typography>

        {/* <Typography variant='h5'>
        Profile Page
        First name
        Last name
        Mobile
      </Typography> */}

      </Box>

    </React.Fragment>
  );
}